import 'mapbox-gl/dist/mapbox-gl.css';
import './assets/css/App.css';

import { ChakraProvider } from '@chakra-ui/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { LogWebSocketProvider } from 'contexts/LogWebSocketContext';
import GlobalProvider from 'contexts/providers/GlobalProvider';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { queryClient } from 'services/queryClient/queryClient';

import AppRoutes from './app.routes';
import theme from './theme/theme';
// pagina do tipo componente funcional FC

const App: React.FC = () => {
	return (
		<QueryClientProvider client={queryClient}>
			<GlobalProvider>
				<ChakraProvider theme={theme}>
					<LogWebSocketProvider>
						<BrowserRouter>
							<AppRoutes />
						</BrowserRouter>
					</LogWebSocketProvider>
				</ChakraProvider>
			</GlobalProvider>
		</QueryClientProvider>
	);
};

export default App;

// requisição get
